export const modificationBuilder = data => {
  return {
    urlS3: data.headers['x-upload-content-location']
  };
};
